import React from 'react';
interface PermissionBlockProps {
  isReadOnly?: boolean;
  readOnlyHide?: boolean;
  altElement?: React.ReactNode;
  readOnlyElement?: React.ReactNode;
  message?: string;
  noPermissionMesssage?: string;
  children: React.ReactNode;
}

export const PermissionBlock = ({
  isReadOnly = false,
  readOnlyHide = false,
  altElement = null,
  readOnlyElement = null,
  noPermissionMesssage,
  children,
}: PermissionBlockProps) => {
  // DEBUGGING LOGS - UNCOMMENT AS NEEDED
  // console.log('PermissionBlock - isReadOnly: ', isReadOnly);

  // hide if should be hidden for read-only users/licenses
  if (isReadOnly && readOnlyHide) {
    return <></>;
  }

  const userHasPermission = () => {
    // check if user has required roles or is an admin
    // if (isReadOnly) {
    //   return false;
    // }
    return true;
  };

  // if user doesn't have permission, don't display children
  if (!userHasPermission()) {
    if (readOnlyElement && isReadOnly) {
      return <>{readOnlyElement}</>;
    }

    if (altElement) {
      return <>{altElement}</>;
    }

    if (noPermissionMesssage) {
      return (
        <>
          <div className="no-permission">{noPermissionMesssage}</div>
        </>
      );
    }

    return <>zzz</>;
  }

  return <>{children}</>;
};
